<template>
    <my-form v-model="form" table >
        <el-form-item label="审核意见" prop="shyj" class="table-full-row">
            <el-input v-model="form.shyj" type="textarea" :rows="4"></el-input>
        </el-form-item>
        <el-form-item label="是否取消标书款" prop="form.isbsk" class="table-full-row" v-if="is_show">
            <el-radio v-model="form.isbsk" :label="true">是</el-radio>
            <el-radio v-model="form.isbsk" :label="false">否</el-radio>
        </el-form-item>


        <template slot="btn" class="btn">
            <el-button icon="el-icon-circle-close" type="danger" @click="funSend('3')"  >
                退回
            </el-button>    
            <el-button icon="el-icon-circle-check" type="primary" @click="funSend('9')">
                通过
            </el-button>
        </template>
    </my-form>
</template>

<script>
import FORM_PAGE_MIXIN from "@views/mixins/form-page";

export default {
    mixins: [FORM_PAGE_MIXIN],
    props: ['rows','back'],
    data() {
        var that = this;
        return {
            form:{
                shyj:'',
                isbsk:false,
            },
            is_show:false,
        };
    },
    methods: {
        funSend(val) {
            var that = this
            if(val==='3'&&!that.form.shyj){
                ShowMsg('请填写退回意见！','error');
                return;
            }else{
                if(this.$route.query.isXt==='1'){
                    that.$post(`${this.getGetters('bidUrl')}/Zbdl/AuditBmZl/xingtai/sh.json`, {
                        shbj:val,
                        shyj:escape(that.form.shyj),
                        rows:that.rows,
                        isbsk:that.form.isbsk,
                    }, (data, res) => {
                        ShowMsg('审核成功', 'success');        
                        if(this.back=='0') {
                             this.$router.go(-1)
                        }
                       
                        that.cancleHandler();
                    });
                }else{
                    that.$post(`${this.getGetters('bidUrl')}/Zbdl/AuditBmZl/sh.json`, {
                        shbj:val,
                        shyj:escape(that.form.shyj),
                        rows:that.rows,
                        isbsk:that.form.isbsk,
                    }, (data, res) => {
                        ShowMsg('审核成功', 'success');
                         if(this.back=='0') {
                             this.$router.go(-1)
                        }
                        that.cancleHandler();
                    });  
                }

            }
        },
        cancleHandler() {
            this.$emit('cancle','1');
        }
    },
    created() {
        var that = this
        that.$get(`${that.getGetters('bidUrl')}/Zbdl/AuditBmZl/list.json`, {
            procode:that.getQuery('procode'),
        }, (data, res) => {
            that.is_show = data.is_show;
        });  
         
    }
};
</script>

<style lang="scss" scoped>
</style>